// Program pulse (approved HTML component: executive-program-pulse).
import type { ReactNode } from 'react';

export interface ExecutiveProgramPulseProps {
  rows: Array<{ label: string; value: string }>;
}

export function ExecutiveProgramPulse({ rows }: ExecutiveProgramPulseProps): ReactNode {
  return (
    <section className="exec-card" data-component="executive-program-pulse">
      <div className="exec-head">
        <h2>Program pulse</h2>
        <small>Selected period</small>
      </div>
      <div className="exec-body source-list">
        {rows.map(row => (
          <div key={row.label}>
            <span>{row.label}</span>
            <strong>{row.value}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
